module.exports = __webpack_public_path__ + "img/PetIcon.b6fb8b56.svg";